import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react'

import { CreateUserFeedbackForm } from './CreateUserFeedbackForm'
import { CreateUserFeedbackModalHeader } from './CreateUserFeedbackModalHeader'

interface FeedbackModalIProps {
  isOpen: boolean
  onClose: () => void
}

export const CreateUserFeedbackModal = ({
  isOpen,
  onClose,
}: FeedbackModalIProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='xl'>
      <ModalOverlay />
      <ModalContent bg='#fff' rounded='20px'>
        <CreateUserFeedbackModalHeader title='Send Feedback' />
        <ModalBody p={0}>
          <Box px={6} py={2}>
            <CreateUserFeedbackForm onClose={onClose} />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
